import React from 'react';
import { FiActivity,FiCalendar , FiAward } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiActivity />,
        title: 'Workshops',
        description: 'Learning new technologies by experts.',
        link:'#'
    },
    {
        icon: <FiAward />,
        title: 'Contests',
        description: 'Putting brillant minds to the challange.',
        link:'#'
    },
    {
        icon: <FiCalendar />,
        title: 'Events',
        description: 'Seminars, Meetings and Online calls.',
        link:'/events'
    },
]

const ServiceSB = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , index) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={index}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to={val.link} dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceSB;